import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW4500Model } from '../kymw4500.model';

// レスポンス構造
export interface GetCatalogFixFlagResponse {
  CatalogFixFlag: string;
}

/**
 * 企画確定フラグ取得
 *
 * @export GetCatalogFixFlagService
 * @class GetCatalogFixFlagService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetCatalogFixFlagService extends PlessJsonResponderSub<GetCatalogFixFlagResponse> {
  private mediumType: string;
  private orderCode: string;
  private successFunc: Function;
  private model: KYMW4500Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCatalogFixFlagService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode
      },
    });
  }

  /**
   * API呼び出し
   * @param model
   * @param successFunc
   * @memberof GetCatalogFixFlagService
   */
  execute(model: KYMW4500Model, successFunc: Function = null): void {
    this.model = model;
    this.orderCode = model.orderCode;
    this.successFunc = successFunc;
    this.send('getCatalogFixFlag', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCatalogFixFlagService
   */
  success(data: GetCatalogFixFlagResponse) {
    this.model.setCatalogFixFlag(data);
    if (this.successFunc) this.successFunc();
  }
}
